module.exports = __webpack_public_path__ + "img/authentic.79dd3ac8.svg";